import RegularText from "@base/RegularText";
import React, { Component } from "react";
import { View, StyleSheet, Platform } from "react-native";
import Icon from "@components/icons";
import { colors } from "@styles/globalStyles";
import Currency from "@core/currencies/Currency";

import i18n from "@i18n/i18n";
import NFT from "@custom-types/NFTModel";
import ImageBase from "@components/image/ImageBase";
import { trimHelper } from "@utils/helpers/chat/chat.helper";
import BoldText from "@base/BoldText";
import Row from "@base/Row";
import { getColorOpacity } from "@utils/helpers/global/global";
import { REDEEMABLE } from "@custom-types/ExpercienceModel";
import { getRedeemableIcon } from "@screens/experiences/components/helpers/redeemable.helper";
import AvatarBase from "@components/avatar/AvatarBase";

interface Props {
    redeemable: Partial<REDEEMABLE>;
    owner: boolean;
}

interface State {}

const { t } = i18n;

export default class ReddemableMessage extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
    }

    render() {
        return (
            <View style={{ overflow: "hidden", padding: 5, marginTop: -5, maxWidth: 250 }}>
                <ImageBase
                    style={{
                        width: "100%",
                        height: 125,
                        resizeMode: "cover",
                        borderTopLeftRadius: 10,
                        borderTopRightRadius: 10,
                    }}
                    autoSizeWidth={true}
                    uri={this.props.redeemable?.redeemableOption.image.carousel || ""}
                ></ImageBase>

                <Row style={{ alignItems: "center", paddingTop: 5 }}>
                    <View style={styles.circle}>
                        <RegularText fontSize={10}>
                            {getRedeemableIcon(this.props.redeemable.redeemableOption.type)}
                        </RegularText>
                    </View>

                    <RegularText style={{ paddingLeft: 3 }} fontSize={12}>
                        {trimHelper(this.props.redeemable?.redeemableOption?.name, 25)}
                    </RegularText>
                </Row>

                <Row style={{ alignItems: "center", paddingTop: 5 }}>
                    <AvatarBase
                        size={20}
                        uri={this.props.redeemable?.experience?.merchant?.image?.thumbnail}
                        alias={this.props.redeemable?.experience?.merchant?.name}
                    ></AvatarBase>
                    <RegularText style={{ paddingLeft: 3 }} fontSize={12}>
                        By{" "}
                        <BoldText fontSize={12}>
                            {trimHelper(this.props.redeemable?.experience?.merchant?.name, 20)}
                        </BoldText>
                    </RegularText>
                </Row>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        minWidth: 230,
        paddingHorizontal: 0,
        paddingTop: 10,
        paddingBottom: 5,
    },
    circleWrapper: {
        position: "absolute",
        top: 15,
        left: 15,
    },
    circle: {
        height: 20,
        width: 20,
        borderRadius: 10,
        backgroundColor: colors.tertiaryShadow,
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
    },
});
